// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"68":"business","443":"about","631":"contact","697":"news"}[chunkId] || chunkId) + "." + {"68":"91e8c7ca","443":"836b7c55","564":"c262bdaa","631":"2bcc00aa","697":"662a94f4"}[chunkId] + ".js";
};